import React from 'react';
import { withTranslation } from 'react-i18next';

const phoneNumbers = [
    {
        region: 'na',
        number: '+1 866 897 8129'
    },
    {
        region: 'uk',
        number: '+44(0) 186 584 4752'
    },
    {
        region: 'fr',
        number: '+33(0)1 71 72 48 50'
    },
    {
        region: 'de',
        number: '+49(0)211 417435 40'
    },
    {
        region: 'nl',
        number: '+31(0)20 485 3456'
    }
];

class CustomerSupportCall extends React.PureComponent {
    constructor(props) {
        super(props);
        this.renderPhoneNumber = this.renderPhoneNumber.bind(this);
    }

    render() {
        return (
            <div className="customer-support-item customer-support-item--call">
                <h5 className="customer-support-item__title fo-icon fo-icon-Support">
                    {this.props.t('common:customerSupport.titleCall')}
                </h5>
                <ul className="customer-support-item__list text-14">{phoneNumbers.map(this.renderPhoneNumber)}</ul>
            </div>
        );
    }

    renderPhoneNumber(phoneNumber, index) {
        return (
            <li key={index} className="customer-support-item__list-item customer-support-item__list-item--phone-number">
                <label className="customer-support-item__list-label">
                    {this.props.t(`common:customerSupport.regions.${phoneNumber.region}`)}
                </label>
                <span className="customer-support-item__list-text">{phoneNumber.number}</span>
            </li>
        );
    }
}

export default withTranslation(['common'])(CustomerSupportCall);
